export const colors = {
  gray: {
    50: '#F3F6FC',
    100: '#E4E8F1',
    200: '#CCD2E0',
    300: '#A6ADBF',
    400: '#878EA1',
    500: '#666D7D',
    600: '#424857',
    700: '#303540',
    800: '#212631',
    900: '#191C24',
  },
  whiteAlpha: {
    50: 'rgba(255, 255, 255, 0.04)',
    100: 'rgba(255, 255, 255, 0.06)',
    200: 'rgba(255, 255, 255, 0.08)',
    300: 'rgba(255, 255, 255, 0.16)',
    400: 'rgba(255, 255, 255, 0.24)',
    500: 'rgba(255, 255, 255, 0.36)',
    600: 'rgba(255, 255, 255, 0.48)',
    700: 'rgba(255, 255, 255, 0.64)',
    800: 'rgba(255, 255, 255, 0.80)',
    900: 'rgba(255, 255, 255, 0.92)',
  },
  blackAlpha: {
    50: 'rgba(0, 0, 0, 0.04)',
    100: 'rgba(0, 0, 0, 0.06)',
    200: 'rgba(0, 0, 0, 0.08)',
    300: 'rgba(0, 0, 0, 0.16)',
    400: 'rgba(0, 0, 0, 0.24)',
    500: 'rgba(0, 0, 0, 0.36)',
    600: 'rgba(0, 0, 0, 0.48)',
    700: 'rgba(0, 0, 0, 0.64)',
    800: 'rgba(0, 0, 0, 0.80)',
    900: 'rgba(0, 0, 0, 0.92)',
  },
  utility: {
    50: 'rgba(0, 17, 51, 0.02)',
    100: 'rgba(0, 17, 51, 0.05)',
    200: 'rgba(0, 17, 51, 0.1)',
    300: 'rgba(0, 17, 51, 0.2)',
    400: 'rgba(0, 17, 51, 0.33)',
    500: 'rgba(0, 17, 51, 0.5)',
    600: 'rgba(0, 17, 51, 0.67)',
    700: 'rgba(0, 17, 51, 0.75)',
    800: 'rgba(0, 17, 51, 0.84)',
    900: '#001133',
  },
  yellow: {
    50: '#FCF7DC',
    100: '#FCF0B3',
    200: '#FAE48C',
    300: '#FCD75D',
    400: '#FFBB00',
    500: '#E5A100',
    600: '#CC8800',
    700: '#945E00',
    800: '#663D00',
    900: '#422600',
  },
  orange: {
    50: '#FCF0DE',
    100: '#FDE3C3',
    200: '#FCD09D',
    300: '#FCB874',
    400: '#FC963D',
    500: '#F2700C',
    600: '#D65600',
    700: '#A83E00',
    800: '#702500',
    900: '#471500',
  },
  red: {
    50: '#FCE3E1',
    100: '#FFD0CF',
    200: '#FDBABA',
    300: '#FA878B',
    400: '#FC5D68',
    500: '#E02D3F',
    600: '#BF1B31',
    700: '#990921',
    800: '#6B0015',
    900: '#470011',
  },
  pink: {
    50: '#FCE1E9',
    100: '#FFCFDF',
    200: '#FDB5CF',
    300: '#FC88B7',
    400: '#F55399',
    500: '#E01B77',
    600: '#C20865',
    700: '#9C0254',
    800: '#750042',
    900: '#4D002E',
  },
  purple: {
    50: '#FCE3FB',
    100: '#FCD4FB',
    200: '#FAB9FA',
    300: '#EF8DF2',
    400: '#D360DB',
    500: '#AF33BD',
    600: '#8C199E',
    700: '#6C0680',
    800: '#470059',
    900: '#2D003B',
  },
  violet: {
    50: '#EFE3FC',
    100: '#E4D1FC',
    200: '#D4B9FA',
    300: '#B78FF7',
    400: '#9D6BFA',
    500: '#8047FC',
    600: '#6030DB',
    700: '#4922BF',
    800: '#2C118F',
    900: '#100059',
  },
  indigo: {
    50: '#E5EAFF',
    100: '#D4D9FC',
    200: '#BEC4FA',
    300: '#9EA4F7',
    400: '#787CF5',
    500: '#5B5BF5',
    600: '#443FE0',
    700: '#2F24C9',
    800: '#1E1385',
    900: '#0E0352',
  },
  blue: {
    50: '#E3F1FC',
    100: '#CAE4FC',
    200: '#B0D5FD',
    300: '#7DB5FA',
    400: '#4C95FC',
    500: '#126DFF',
    600: '#0049DB',
    700: '#0033BB',
    800: '#002288',
    900: '#001144',
  },
  cyan: {
    50: '#DCF4FA',
    100: '#BEECFA',
    200: '#91DCF8',
    300: '#4CC7FC',
    400: '#00AAFF',
    500: '#0077CC',
    600: '#0058AB',
    700: '#004085',
    800: '#00306B',
    900: '#001D47',
  },
  teal: {
    50: '#DAF7F2',
    100: '#B7F7EF',
    200: '#88EBE1',
    300: '#51DBD2',
    400: '#00C2BB',
    500: '#00A6A6',
    600: '#008085',
    700: '#006269',
    800: '#004047',
    900: '#002C33',
  },
  green: {
    50: '#DCF7E7',
    100: '#BBF2D3',
    200: '#96E9BC',
    300: '#50DE97',
    400: '#10C470',
    500: '#00A15B',
    600: '#008751',
    700: '#006641',
    800: '#00452E',
    900: '#003022',
  },
};
